export const TABLE_SELECTION = [
    { label: "None", value: "none" },
    { label: "Single", value: "single" },
    { label: "Multiple", value: "multiple" }
];

export const TABLE_SEPARATOR = [
    { label: "None", value: "none" },
    { label: "Horizontal", value: "horizontal" },
    { label: "Vertical", value: "vertical" },
    { label: "Cell", value: "cell" }
];

export const TABLE_CONFIG = [
    {
        name: "column1",
        required: true,
        align: "left",
        label: "Column 1",
        field: "column1",
        visible: true,
        sortable: true,
        headerStyle: "min-width:300px"
    },
    {
        name: "column2", align: "left", label: "Column 2", field: "column2", visible: true, sortable: true, headerStyle: "min-width:200px"
    },
    {
        name: "column3", align: "left", label: "Column 3", field: "column3", visible: true, sortable: true, headerStyle: "min-width:300px"
    },
    {
        name: "column4", align: "left", label: "Column 4", field: "column4", visible: true, sortable: true, headerStyle: "min-width:400px"
    },
    {
        name: "column5", align: "left", label: "Column 5", field: "column5", visible: true, sortable: true, headerStyle: "min-width:300px"
    },
    {
        name: "column6", align: "left", label: "Column 6", field: "column6", visible: true, headerStyle: "min-width:200px"
    }
];

export const TABLE_CONFIG2 = [
    {
        name: "column0", align: "center", label: "", field: "column0", visible: true
    },
    {
        name: "column1", align: "center", label: "Column 1", field: "column1", visible: true
    },
    {
        name: "column2", align: "left", label: "Column 2", field: "column2", visible: true
    },
    {
        name: "column3", align: "left", label: "Column 3", field: "column3", visible: true
    },
    {
        name: "column4", align: "left", label: "Column 4", field: "column4", visible: true
    },
    {
        name: "column5", align: "left", label: "Column 5", field: "column5", visible: true
    },
    {
        name: "column6", align: "left", label: "Column 6", field: "column6", visible: true
    }
];

export const TABLE_COLUMNS_DATA = [
    {
        id: "1", column1: "cell 1_1", column2: "cell 2_1", column3: "cell 3_1", column4: "cell 4_1", column5: "cell 5_1", column6: "cell 6_1"
    },
    {
        id: "2", column1: "cell 1_2", column2: "cell 2_2", column3: "cell 3_2", column4: "cell 4_2", column5: "cell 5_2", column6: "cell 6_2"
    },
    {
        id: "3", column1: "cell 1_3", column2: "cell 2_3", column3: "cell 3_3", column4: "cell 4_3", column5: "cell 5_3", column6: "cell 6_3"
    },
    {
        id: "4", column1: "cell 1_4", column2: "cell 2_4", column3: "cell 3_4", column4: "cell 4_4", column5: "cell 5_4", column6: "cell 6_4"
    },
    {
        id: "5", column1: "cell 1_5", column2: "cell 2_5", column3: "cell 3_5", column4: "cell 4_5", column5: "cell 5_5", column6: "cell 6_5"
    },
    {
        id: "6", column1: "cell 1_6", column2: "cell 2_6", column3: "cell 3_6", column4: "cell 4_6", column5: "cell 5_6", column6: "cell 6_6"
    },
    {
        id: "7", column1: "cell 1_7", column2: "cell 2_7", column3: "cell 3_7", column4: "cell 4_7", column5: "cell 5_7", column6: "cell 6_7"
    },
    {
        id: "8", column1: "cell 1_8", column2: "cell 2_8", column3: "cell 3_8", column4: "cell 4_8", column5: "cell 5_8", column6: "cell 6_8"
    },
    {
        id: "9", column1: "cell 1_9", column2: "cell 2_9", column3: "cell 3_9", column4: "cell 4_9", column5: "cell 5_9", column6: "cell 6_9"
    },
    {
        id: "10", column1: "cell 1_10", column2: "cell 2_10", column3: "cell 3_10", column4: "cell 4_10", column5: "cell 5_10", column6: "cell 6_10"
    }
];

export const TABLE_COLUMNS_DATA_SECOND = [
    {
        id: "11", column1: "cell 1_11", column2: "cell 2_11", column3: "cell 3_11", column4: "cell 4_11", column5: "cell 5_11", column6: "cell 6_11"
    },
    {
        id: "12", column1: "cell 1_12", column2: "cell 2_12", column3: "cell 3_12", column4: "cell 4_12", column5: "cell 5_12", column6: "cell 6_12"
    },
    {
        id: "13", column1: "cell 1_13", column2: "cell 2_13", column3: "cell 3_13", column4: "cell 4_13", column5: "cell 5_13", column6: "cell 6_13"
    },
    {
        id: "14", column1: "cell 1_14", column2: "cell 2_14", column3: "cell 3_14", column4: "cell 4_14", column5: "cell 5_14", column6: "cell 6_14"
    },
    {
        id: "15", column1: "cell 1_15", column2: "cell 2_15", column3: "cell 3_15", column4: "cell 4_15", column5: "cell 5_15", column6: "cell 6_15"
    },
    {
        id: "16", column1: "cell 1_16", column2: "cell 2_16", column3: "cell 3_16", column4: "cell 4_16", column5: "cell 5_16", column6: "cell 6_16"
    },
    {
        id: "17", column1: "cell 1_17", column2: "cell 2_17", column3: "cell 3_17", column4: "cell 4_17", column5: "cell 5_17", column6: "cell 6_17"
    },
    {
        id: "18", column1: "cell 1_18", column2: "cell 2_18", column3: "cell 3_18", column4: "cell 4_18", column5: "cell 5_18", column6: "cell 6_18"
    },
    {
        id: "19", column1: "cell 1_19", column2: "cell 2_19", column3: "cell 3_19", column4: "cell 4_19", column5: "cell 5_19", column6: "cell 6_19"
    },
    {
        id: "20", column1: "cell 1_20", column2: "cell 2_20", column3: "cell 3_20", column4: "cell 4_20", column5: "cell 5_20", column6: "cell 6_20"
    }
];
